export const FETCH_PROPERTY = "FETCH_PROPERTY";
export const GET_PROPERTY_IMAGES = "GET_PROPERTY_IMAGES";
export const DELETE_PROPERTY_IMAGES = "DELETE_PROPERTY_IMAGES";
export const FILL_PROPERTY_IMAGES = "FILL_PROPERTY_IMAGES";
export const UPDATE_PROPERTY_IMAGES = "UPDATE_PROPERTY_IMAGES";
export const UPDATE_PROPERTY_NOTES = "UPDATE_PROPERTY_NOTES";
export const FILL_PROPERTY_NOTES = "FILL_PROPERTY_NOTES";
